import GentleWidget from '../common/widget';
import GentleLang from '../common/lang';
import GentleApi from '../common/api';
import GentleUtil from '../common/util'

// 버블
var GentleComponentTimeStamp = Object.create( GentleWidget );

GentleComponentTimeStamp.timeString = function(){
    let time;
    var dt = new Date();
    var hour = dt.getHours();
    var min = GentleUtil.pad(dt.getMinutes(), 2);
    if (hour >= 12){
        if(hour > 12)
            hour = hour - 12;
            
        hour = GentleUtil.pad(hour, 2);
        time = GentleLang.translate(GentleLang.type.TimePm, {h: hour, m: min})
    }
    else{
        time = GentleLang.translate(GentleLang.type.TimeAm, {h: hour, m: min})
    }

    return time;
}

GentleComponentTimeStamp.createComponent = function(option){

    const time = GentleComponentTimeStamp.timeString();

    let html;
    if(option.user === 'user'){
        html = `
            <div class="speech-date user">${time}</div>        
        `;
    }
    else{
        html = `
        
            <div class="speech-date bot">${time}</div>
        
        `;
    }
    const $element = $(html);
    this.setPrefix('timeStamp');
    this.init( $element );
    return;
}

export default GentleComponentTimeStamp;
